<!-- 图片链接列表：模块头+图片+标题+链接 -->
<template>
<div class="content-block">
  <div class="info-list-title">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <a href="#" v-if="showMore">更多</a>
  </div>
  <div class="info-list-content">
    <div class="list-container">
      <div class="list-container-cell" :style="{'width': celWidth}">
        <router-link :to="{path: '/cybg'}" v-bind:style="{backgroundImage:'url('+require('./../../assets/home_data_1.png')+')'}">

        </router-link>
      </div>
      <div class="list-container-cell" :style="{'width': celWidth}">
        <router-link :to="{path: '/hync'}" v-bind:style="{backgroundImage:'url('+require('./../../assets/home_data_2.png')+')'}">

        </router-link>
      </div>
      <div class="width-per-100 other-image-01">
        <div class="image-01" v-bind:style="{backgroundImage:'url('+require('./../../assets/product_1.png')+')'}">
          <div class="cell-base-info">
            <div class="title">{{newsList[2].title}}</div>
            <div class="label">{{newsList[2].label}}</div>
          </div>
          <div class="cell-detail-info">
            <div class="detail">{{newsList[2].remark}}</div>
            <div class="detail-more">
              <router-link :to="{path: '/intro'}">
                了解详情
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ImgLink02',
  props: {
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: true
    },
    col: {
      type: String,
      default: '3'
    },
    count: {
      type: String,
      default: '3'
    }
  },
  data() {
    return {
      celWidth: "calc(100%/" + this.col + ")",
      newsList: []
    }
  },
  created:function(){
    this.newsList=this.Global.dataServiceList;
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
a {
  color: #42b983;
  text-decoration: none;
}

.list-container {
  display: flex;
  flex-wrap: wrap;
}

.list-container-cell {
  box-sizing: border-box;
  height: 160px;
  background: #fff;
  border: 0px solid red;
}

.list-container-cell a {
  display: block;
  height:130px;
  box-sizing: border-box;
  padding:30px 100px 30px 100px;
  margin:15px;
  border-radius:10px;
  background-color: #fff;
  border:1px solid #eee;
  background-repeat: no-repeat;
  background-position: center center;
}

.list-container-cell a:hover{
  border:1px solid #eee;
  box-shadow:0px 0px 1px 1px #eee;
}

.list-container-cell .cell-base-info{
  position:relative;
  height:70px;
  width:100%;
  color:#fff;
  border-radius:15px;
  padding-right:0px;
  background:#000;
  opacity:1;
}

.other-image-01 {
  box-sizing: border-box;
  height: 160px;
  background: #fff;
  border: 0px solid red;
}

.other-image-01 .image-01{
  height:160px;
  box-sizing: border-box;
  padding:0px 0px 0px 200px;
  margin:15px;
  border-radius:0px;
  background-color: #fff;
  border:1px solid #ddd;
  background-repeat: no-repeat;
  background-position: 20px center;
  background-size:140px auto;
}

.other-image-01 .image-01:hover{
  border:1px solid #eee;
  box-shadow:0px 0px 1px 1px #eee;
  cursor:pointer;
}

.other-image-01 .cell-base-info{
  position:relative;
  float:left;
  width:30%;
  height:160px;
  color:#000;
}
.other-image-01 .cell-detail-info{
  position:relative;
  float:left;
  height:160px;
  padding:30px;
  width:70%;
  color:#000;
}

.other-image-01 .title{
  padding:30px 10px 10px 40px;
  font-size:18px;
  color:var(--color7);
}

.other-image-01 .label{
  padding:5px 10px 10px 40px;
  font-size:12px;
  line-height:20px;
  color:#888888;
}

.other-image-01 .detail{
  float:left;
  padding:0px 20px 0px 10px;
  width:80%;
  height:100px;
  font-size:12px;
  line-height:20px;
  color:#888888;
  border-left:1px solid #bbbbbb;
}

.other-image-01 .detail-more{
  float:left;
  width:20%;
  line-height:160px;
}

.detail-more a{
  display:block;
  margin-top:35px;
  height:30px;
  width:100px;
  color: var(--color2);
  line-height:30px;
  text-align:center;
  border:1px solid var(--color2);
}

.detail-more a:hover{
  color:#fff;
  background: var(--color2);
}

.cell-base-info .base-info-title{
  float:left;
  height:40px;
  margin-left:80px;
  font-size:16px;
  font-weight:600;
  line-height:40px;
}

.cell-base-info .base-info-label{
  float:left;
  height:30px;
  margin-left:80px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  left:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:35px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

</style>



// WEBPACK FOOTER //
// src/components/block/ImgLink02.vue